// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"594d6faa","787":"86a868da"}[chunkId] + ".chunk.js";
};